import { ComponentPropsWithoutRef } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../components/chadcn/Tooltip";
import cn from "../../util/cn";

type NewDataTooltipIndicatorProps = ComponentPropsWithoutRef<"div">;

const NewDataTooltipIndicator = ({ className, ...otherProps }: NewDataTooltipIndicatorProps) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger className="flex items-center">
        <div
          className={cn("inline-block size-2 rounded-full bg-blue-400", className)}
          {...otherProps}
        />
      </TooltipTrigger>
      <TooltipContent className="select-none font-semibold text-blue-400 shadow-lg ring-1 ring-slate-200">
        New
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default NewDataTooltipIndicator;
